import { useQuery } from "react-query"
import dataAPI from "../../services/dataAPI"

export default function useLastConsumptionIndexFormatted(device_name?: string) {
  const consumptionIndexQuery = useQuery({
    queryKey: ['consumption-index-last', device_name],
    queryFn: () => {
      const filterWithDevice = { device_name: device_name || '' }
      return dataAPI.getLastConsumptionIndexSingleCounter(filterWithDevice)
    },
    enabled: !!device_name
  })

  const formatValue = (value: number | undefined, decimals: number = 2): string => {
    if (value === undefined || value === null) return 'NA'
    return Number(value).toFixed(decimals)
  }

  const getStatus = (value: number | undefined): 'ok' | 'warning' | 'danger' => {
    if (value === undefined || value === null) return 'danger'
    // Index de consommation: valeur positive = ok
    if (value >= 0) return 'ok'
    return 'danger'
  }

  return {
    consumptionIndexQuery: {
      data: consumptionIndexQuery.data,
      isLoading: consumptionIndexQuery.isLoading,
      isSuccess: consumptionIndexQuery.isSuccess,
      isError: consumptionIndexQuery.isError,
      error: consumptionIndexQuery.error,
      refetch: consumptionIndexQuery.refetch,
      isRefetching: consumptionIndexQuery.isRefetching
    },
    consumptionIndexValue: consumptionIndexQuery.data?.[0]?.Value,
    formattedConsumptionIndex: formatValue(consumptionIndexQuery.data?.[0]?.Value, 2),
    consumptionIndexStatus: getStatus(consumptionIndexQuery.data?.[0]?.Value),
    consumptionIndexTime: consumptionIndexQuery.data?.[0]?.Time,
    isLoading: consumptionIndexQuery.isLoading
  }
}

